<template>
  <div
    id=""
    class="tela-funcoes"
  >
    <v-container>
      <v-toolbar
        color="primary"
        dark
        class="mb-2"
      >
        Adicionar ou editar colaboradores em funcões diversas
      </v-toolbar>

      <input
        id="user-id"
        type="hidden"
        v-model="funcao.usuario"
      />
      <input
        id="uid_lei"
        type="hidden"
        v-model="funcao.uid_lei"
      />
      <input
        id="funcao-id"
        type="hidden"
        v-model="funcao.id"
      />
      <v-row>
        <v-col
          cols="12"
          md="2"
        >
          <v-text-field
            v-model="codigo"
            label="Código"
            dense
            outlined
          >
            <v-btn
              class="btn-outer-right pa-0"
              slot="append"
              color="success"
              tile
              @click.prevent="loadDialog"
            >
              <v-icon
                class="mx-0"
                color="white"
              >
                mdi-magnify
              </v-icon>
            </v-btn>
          </v-text-field>
        </v-col>
        <v-col
          colls="12"
          lg="3"
          md="4"
          v-if="codigo"
        >
          <v-checkbox
            v-model="funcao.inativar"
            label="Inativar o fiscal?"
            color="success"
            class="mt-4"
          >
          </v-checkbox>
        </v-col>
      </v-row>
      <v-row>
        <v-col
          cols="12"
          md="3"
          lg="3"
        >
          <v-text-field
            v-model="funcaoCod"
            label="Código..."
            dense
            outlined
            flat
            @change="loadPessoaSelect()"
          >
            <v-btn
              class="btn-outer pa-0"
              slot="append"
              color="success"
              tile
            >
              <v-icon
                class="mx-0"
                color="white"
              >
                mdi-magnify
              </v-icon>
            </v-btn>
            <v-btn
              class="btn-outer-right pa-0"
              slot="append"
              color="light"
              tile
              @click="loadAddPessoa"
            >
              <v-icon
                class="mx-0"
                color="black"
              >
                mdi-plus
              </v-icon>
            </v-btn>
          </v-text-field>
        </v-col>
        <v-col
          cols="12"
          md="6"
          lg="5"
        >
          <v-text-field
            v-if="funcaoCont"
            v-model="funcaoCont"
            label="Autor ou interessado"
            outlined
            dense
            class="ml-n6"
          >
            <v-icon
              v-if="funcaoCont"
              slot="append"
              color="black"
              @click="clPessoa"
            >
              mdi-close
            </v-icon>
          </v-text-field>
          <v-autocomplete
            v-if="!funcaoCont"
            v-model="filtro"
            :items="funcoes"
            :search-input.sync="ftpessoa"
            cache-items
            dense
            outlined
            hide-no-data
            hide-details
            label="Responsável"
            class="ml-n6"
            @change="loadPessoaSelect()"
          >
          </v-autocomplete>
        </v-col>
        <v-col
          cols="12"
          md="3"
        >
          <v-autocomplete
            v-model="funcao.uid_tipo"
            :items="tipoFuncao"
            label="Tipo de atribuição"
            dense
            outlined
            clearable
          ></v-autocomplete>
        </v-col>
      </v-row>
      <v-row>
        <v-col
          cols="12"
          md="4"
          lg="4"
        ><v-text-field
            v-model="funcao.base"
            label="Base legal"
            dense
            outlined
          ></v-text-field>
        </v-col>
        <v-col
          cols="12"
          md="8"
          lg="7"
        ><v-text-field
            v-model="funcao.url"
            label="Link da lei"
            dense
            outlined
          >
            <v-btn
              v-if="!funcao.uid_lei"
              class="btn-outer-left pa-0"
              slot="append"
              color="success"
              tile
              @click.prevent="loadAddLei()"
            >
              <v-icon
                class="mx-0"
                color="white"
              >
                mdi-upload-outline
              </v-icon>
            </v-btn>
            <v-btn
              v-if="funcao.uid_lei"
              class="btn-outer-left pa-0"
              slot="append"
              color="warning"
              tile
              @click.prevent="loadDelLei()"
            >
              <v-icon
                class="mx-0"
                color="white"
              >
                mdi-delete-outline
              </v-icon>
            </v-btn>
            <v-btn
              v-if="funcao.uid_lei"
              class="btn-outer-right-1 pa-0"
              slot="append-outer"
              color="success"
              tile
              @click.prevent="loadVerLei()"
            >
              <v-icon
                class="mx-0"
                color="white"
              >
                mdi-eye-outline
              </v-icon>
            </v-btn>
          </v-text-field>
        </v-col>
      </v-row>
      <v-row>
        <v-col
          cols="12"
          md="3"
          lg="2"
        >
          <v-menu
            v-model="menuIn"
            :close-on-content-click="false"
            :nudge-right="40"
            transition="scale-transition"
            offset-y
            min-width="auto"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-text-field
                v-mask="dtIn"
                v-model="dataIn"
                label="Data início.:"
                dense
                outlined
                @blur="mudaDataA"
              >
                <v-icon
                  slot="append"
                  color="success"
                  large
                  v-bind="attrs"
                  v-on="on"
                >
                  mdi-calendar
                </v-icon>
              </v-text-field>
            </template>
            <v-date-picker
              locale="pt-br"
              v-model="dateIn"
              @input="dateA"
            >
            </v-date-picker>
          </v-menu>
        </v-col>
        <v-col
          cols="12"
          md="3"
          lg="2"
        >
          <v-menu
            v-model="menuFim"
            :close-on-content-click="false"
            :nudge-right="40"
            transition="scale-transition"
            offset-y
            min-width="auto"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-text-field
                v-mask="dtFim"
                v-model="dataFim"
                label="Data Final.:"
                dense
                outlined
                @blur="mudaDataB"
              >
                <v-icon
                  slot="append"
                  color="success"
                  large
                  v-bind="attrs"
                  v-on="on"
                >
                  mdi-calendar
                </v-icon>
              </v-text-field>
            </template>
            <v-date-picker
              locale="pt-br"
              v-model="dateFim"
              @input="dateB"
            >
            </v-date-picker>
          </v-menu>
        </v-col>
      </v-row>
      <v-card>
        <v-tabs
          background-color="primary"
          dark
          v-model="tabs"
        >
          <v-tab>
            <v-icon class="mr-2">
              mdi-message-text-outline
            </v-icon>
            Atribuições
          </v-tab>
        </v-tabs>
        <v-tabs-items v-model="tabs">
          <v-tab-item>
            <v-card flat>
              <v-row>
                <v-col
                  cols="12"
                  md="12"
                >
                  <v-card class="pa-2">
                    <ckeditor
                      :editor="editor"
                      v-model="funcao.ds_funcao"
                      :config="editorConfig"
                      placeholder="Atribuições"
                    ></ckeditor>
                  </v-card>
                </v-col>
              </v-row>
            </v-card>
          </v-tab-item>
        </v-tabs-items>
      </v-card>
      <v-card-actions class="justify-start my-4">
        <v-btn
          color="success"
          class="mr-4"
          v-if="funcao.id"
          type="submit"
          @click.prevent="save()"
        >
          <v-icon left>
            mdi-content-save
          </v-icon>
          Atualizar
        </v-btn>
        <v-btn
          color="success"
          class="mr-4"
          v-if="!funcao.id"
          type="submit"
          @click.prevent="save()"
        >
          <v-icon left>
            mdi-content-save
          </v-icon>
          Salvar
        </v-btn>
        <v-btn
          color="error"
          class="mr-4 text-none"
          v-if="funcao.id"
          @click="del"
        >
          <v-icon left>
            mdi-delete-alert-outline
          </v-icon>
          Deletar
        </v-btn>
        <v-btn
          color="danger"
          class="mr-4"
          @click="reset"
        >
          <v-icon left>
            mdi-broom
          </v-icon>
          Limpar
        </v-btn>
      </v-card-actions>
    </v-container>
    <v-container>
      <v-dialog
        v-model="dialog"
        transition="dialog-bottom-transition"
        fullscreen
      >
        <template v-slot:default="dialog">
          <v-card>
            <v-toolbar
              color="primary"
              dark
            >
              Pesquisar
            </v-toolbar>
            <v-card-title>
              <v-text-field
                class="search"
                v-model="search"
                append-icon="mdi-magnify"
                label="Pesquisar"
                single-line
                hide-details
              >
              </v-text-field>
            </v-card-title>
            <v-data-table
              :headers="headers"
              :items="funcoes"
              :search="search"
            >
              <template v-slot:[`item.actions`]="{ item }">
                <v-icon
                  medium
                  color="primary"
                  class="mr-2"
                  @click="loadEditFuncao(item)"
                >
                  mdi-square-edit-outline
                </v-icon>
                <v-icon
                  medium
                  color="error"
                  class="mr-2"
                  @click="loadDelFuncao(item)"
                >
                  mdi-delete
                </v-icon>
              </template>
            </v-data-table>
            <v-card-actions class="justify-end">
              <v-btn
                color="error"
                @click="dialog.value = false"
              >Fechar</v-btn>
            </v-card-actions>
          </v-card>
        </template>
      </v-dialog>
    </v-container>
    <v-container>
      <v-dialog
        v-model="dialogFiltro"
        transition="dialog-bottom-transition"
        fullscreen
      >
        <template v-slot:default="dialogFiltro">
          <v-card>
            <v-toolbar
              color="primary"
              dark
            >
              Pesquisar leis
            </v-toolbar>
            <v-card-title>
              <v-text-field
                class="search"
                v-model="search"
                append-icon="mdi-magnify"
                label="Pesquisar"
                single-line
                hide-details
              >
              </v-text-field>
            </v-card-title>
            <v-data-table
              :headers="headerLeis"
              :items="leis"
              :search="search"
            >
              <template v-slot:[`item.actions`]="{ item }">
                <v-icon
                  large
                  color="success"
                  class="mr-2"
                  @click="loadUpLei(item)"
                >
                  mdi-arrow-down-bold-box
                </v-icon>
              </template>
            </v-data-table>
            <v-card-actions class="justify-end">
              <v-btn
                color="error"
                @click="dialogFiltro.value = false"
              >Fechar</v-btn>
            </v-card-actions>
          </v-card>
        </template>
      </v-dialog>
    </v-container>
  </div>
</template>
<script>
import { mapState } from 'vuex'
import { uuid } from 'vue-uuid'
import ClassicEditor from '@ckeditor/ckeditor5-build-classic'
import { baseApiUrl, showError } from '@/global'
import axios from 'axios'
import moment from 'moment'
export default {
  name: 'TelaFuncoes',
  computed: mapState(['user']),
  data: () => ({
    editor: ClassicEditor,
    editorConfig: {
    },
    dtIn: '##/##/####',
    dtFim: '##/##/####',
    dataIn: '',
    dataFim: '',
    dateIn: '',
    dateFim: '',
    funcaoCod: '',
    funcaoCont: '',
    codigo: '',
    uuid: '',
    length: '',
    menuIn: false,
    menuFim: false,
    btn: false,
    dialog: false,
    dialogFiltro: false,
    filtro: null,
    select: null,
    ftpessoa: null,
    tabs: null,
    funcao: {},
    pessoa: {},
    leg: {},
    tipoFuncao: [],
    funcoes: [],
    leis: [],
    headers: [
      {
        text: 'Cód',
        align: 'start',
        sortable: false,
        value: 'id'
      },
      { text: 'Nome', value: 'nome' },
      { text: 'Atribuição', value: 'atribuicao' },
      { text: 'Data início', value: 'inicio' },
      { text: 'Situação', value: 'status', sortable: false },
      { text: 'Ações', value: 'actions', sortable: false }
    ],
    headerLeis: [
      {
        text: 'Cód',
        align: 'start',
        sortable: false,
        value: 'id'
      },
      { text: 'Lei', value: 'numero' },
      { text: 'Ano', value: 'ano' },
      { text: 'Ementa', value: 'ementa' },
      { text: 'Publicação', value: 'data' },
      { text: 'Situação', value: 'situacao', sortable: false },
      { text: 'Ações', value: 'actions', sortable: false }
    ]
  }),
  watch: {
    ftpessoa (val) {
      val && val !== this.filtro && this.querySelectionsResponsavel(val)
    }
  },
  methods: {
    // Sessão de envio ao banco de dados
    save () {
      const method = this.funcao.id ? 'put' : 'post'
      const id = this.funcao.id ? `/${this.funcao.id}` : ''
      axios[method](`${baseApiUrl}/funcoes-especiais${id}`, this.funcao)
        .then(() => {
          this.$toasted.global.defaultSuccess()
          this.reset()
        })
        .catch(showError)
    },
    vincularLei () {
      const id = this.funcao.id
      axios.put(`${baseApiUrl}/funcoes-especiais/${id}`, this.leg)
        .then(() => {
          this.$toasted.global.defaultSuccess()
          this.loadUpdate()
          this.leg = {}
        })
        .catch(showError)
    },
    desvincularLei () {
      const id = this.funcao.id
      if (confirm('Deseja realmente desvincular esta lei?')) {
        axios.put(`${baseApiUrl}/funcoes-especiais/${id}`, this.leg)
          .then(() => {
            this.$toasted.global.defaultSuccess()
            this.loadUpdate()
            this.leg = {}
          })
          .catch(showError)
      }
    },
    // Sessão de deletar no banco de dados
    del () {
      if (confirm('Deseja realmente remover o fiscal?')) {

      }
    },
    loadDelLei () {
      this.leg.uid_lei = null
      this.leg.base = ''
      this.leg.url = ''
      this.leg.exitelei = false
      this.leg.leg = true
      this.desvincularLei()
    },
    // Sessão de filtros ******************************************************
    querySelectionsResponsavel (v) {
      const fpessoa = v || 0
      const url = `${baseApiUrl}/vereadores-de-projetos/${fpessoa}`
      axios.get(url).then(res => {
        this.funcoes = res.data.map(item => {
          return {
            value: item.id,
            text: item.vereador
          }
        })
      })
    },
    loadPessoaSelect () {
      const item = this.filtro
      const id = this.funcaoCod ? `/${this.funcaoCod}` : `/${item}`
      const url = `${baseApiUrl}/vereadores-selecionado${id}`
      axios.get(url).then(res => {
        this.pessoa = res.data
        this.funcao.uid_pessoa = this.pessoa.id
        this.funcao.nome = this.pessoa.vereador
        this.funcaoCod = this.pessoa.id
        this.funcaoCont = this.pessoa.vereador
        this.disabled = true
      })
      //  this.clPessoa()
    },
    loadFuncoes () {
      const url = `${baseApiUrl}/funcoes-especiais-filtro`
      axios.get(url).then(res => {
        this.funcoes = res.data.map(item => {
          return {
            ...item,
            inicio: moment(item.data_inicio).format('DD/MM/YYYY'),
            status: item.inativar === 0 ? 'Ativo' : 'Inativa'
          }
        })
      })
    },
    loadLeis () {
      const url = `${baseApiUrl}/legislacao-filtro-adicionar`
      axios.get(url).then(res => {
        this.leis = res.data.map(item => {
          return {
            ...item,
            data: moment(item.data_publicacao).format('DD/MM/YYYY'),
            inativar: item.inativar === 0 ? 'Ativo' : 'Inativa'
          }
        })
      })
    },
    loadUpdate (cod) {
      const id = cod || this.funcao.id
      const url = `${baseApiUrl}/funcoes-especiais/${id}`
      axios.get(url).then(res => {
        this.funcao = res.data
        this.funcaoCod = this.funcao.id
        this.funcaoCont = this.funcao.nome
        if (this.funcao.data_inicio) {
          this.dataIn = moment(this.funcao.data_inicio).format('DD/MM/YYYY')
          this.funcao.data_inicio = moment(this.funcao.data_inicio).format('YYYY-MM-DD')
        } else {
          this.dataIn = ''
        }
        if (this.funcao.data_fim) {
          this.dataFim = moment(this.funcao.data_fim).format('DD/MM/YYYY')
          this.funcao.data_fim = moment(this.funcao.data_fim).format('YYYY-MM-DD')
        } else {
          this.dataFim = ''
        }
      })
    },
    loadCargos () {
      const url = `${baseApiUrl}/cargos-e-funcoes`
      axios.get(url).then(res => {
        this.tipoFuncao = res.data.map(item => {
          return {
            value: item.id,
            text: item.cargo
          }
        })
      })
    },
    // Sessão de adicionar e editar ************************************
    loadAddPessoa () {

    },
    loadUpLei (item) {
      var cod = this.funcao.id
      if (!cod) {
        this.funcao.uid_lei = item.id
        this.funcao.url = item.url
        this.funcao.exitelei = true
      } else {
        this.leg.uid_lei = item.id
        this.leg.base = this.funcao.base
        this.leg.url = item.url
        this.leg.exitelei = true
        this.leg.leg = true
        this.vincularLei()
      }
      this.dialogFiltro = false
    },
    loadAddLei () {
      this.dialogFiltro = true
      this.loadLeis()
    },
    loadEditFuncao (item) {
      const cod = item.id
      this.loadUpdate(cod)
      this.dialog = false
    },
    // Sessão de limpeza ************************************************
    clPessoa () {
      this.funcaoCod = ''
      this.funcaoCont = ''
      this.pessoa = {}
      this.funcoes = []
    },
    reset () {
      this.codigo = ''
      this.funcaoCod = ''
      this.funcaoCont = ''
      this.dataIn = ''
      this.dataFim = ''
      this.funcao = {}
      this.pessoa = {}
      this.funcoes = []
      this.funcao.usuario = this.user.id
      this.funcao.uuid = uuid.v1()
    },
    // Sessão de datas
    dateA () {
      this.dataIn = moment(this.dateIn).format('DD/MM/YYYY')
      this.menuIn = false
      const [dia, mes, ano] = this.dataIn.split('/')
      this.funcao.data_inicio = `${ano}-${mes.padStart(2, '0')}-${dia.padStart(2, '0')}`
    },
    mudaDataA () {
      const [dia, mes, ano] = this.dataIn.split('/')
      this.funcao.data_inicio = `${ano}-${mes.padStart(2, '0')}-${dia.padStart(2, '0')}`
    },
    dateB () {
      this.dataFim = moment(this.dateFim).format('DD/MM/YYYY')
      this.menuFim = false
      const [dia, mes, ano] = this.dataFim.split('/')
      this.funcao.data_fim = `${ano}-${mes.padStart(2, '0')}-${dia.padStart(2, '0')}`
    },
    mudaDataB () {
      const [dia, mes, ano] = this.dataFim.split('/')
      this.funcao.data_fim = `${ano}-${mes.padStart(2, '0')}-${dia.padStart(2, '0')}`
    },
    // Sessão de dialogs e formularios ***********************************
    loadDialog () {
      this.dialog = true
      this.loadFuncoes()
    },
    loadUser () {
      this.funcao.usuario = this.user.id
      this.funcao.uuid = uuid.v1()
    },
    loadVerLei () {

    }
  },
  mounted () {
    this.loadUser()
    this.loadCargos()
  }
}
</script>

<style scoped>
.text-v-card {
  font-size: 1rem !important;
}
.codigo {
  max-width: 100% !important;
}
.v-busca-nome {
  max-width: 100% !important;
  height: 45px !important;
}
.v-input__prepend-outer {
  padding: 0px !important;
  width: 36px !important;
  height: 36px !important;
}
.btn-outer {
  margin-top: -7px !important;
  margin-left: -9px !important;
}
.btn-outer-right {
  margin-top: -7px !important;
  margin-right: -11px !important;
}
.btn-outer-left {
  margin-top: -6px !important;
  margin-right: -10px !important;
}
.btn-outer-right-1 {
  margin-top: -8px !important;
  margin-left: -12px !important;
  border-top: solid 1px #878f97 !important;
  border-right: solid 1px #878f97 !important;
  border-bottom: solid 1px #878f97 !important;
}
.v-icon-btn {
  margin-top: -7px !important;
  margin-right: -8px !important;
  padding: auto !important;
  background-color: rgb(12, 94, 46);
}
ul.filtro {
  position: absolute;
  min-width: 350px;
  top: 0px;
  left: 40px;
  padding: 2px 6px !important;
  background-color: #feffff;
  border: solid 1px #000;
  list-style: none;
  z-index: 1000;
}
ul.filtro li a {
  text-decoration: none;
  color: #333 !important;
}
ul.filtro li:hover {
  background-color: teal;
  color: #ffffff !important;
}
ul.filtro li a:hover {
  color: #ffffff !important;
}
.container {
  width: 98% !important;
}
.logo-foto {
  max-width: 750px;
}
</style>
